/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- ARTICLE SENTIMENT V2 ANALYTICS - INVIEW/EMBED LOADS REPORT : STYLES --------------- ++++++++++ */
export default {
    inviewembedsloadreport: {
    }
};
